import React from 'react';
import './application.less'

function AppTableNoData({title, subTitle}) {
    return (
        <div className='nodata-container'>
            <div className='nodata-image-container nodata-image'></div>
            <div className='nodata-content-container'>
                <p className='nodata-content-title'>
                    {title}
                </p>
                <p className='nodata-content-subtitle'>
                    {subTitle}
                </p>
            </div>
        </div>
    );
}

export default AppTableNoData;